import { getOrderFulfillmentCTA } from "./shared";
export var AddressAndPhoneNumber = function AddressAndPhoneNumber(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "uNzg15",
        defaultMessage: [{
          "type": 0,
          "value": "Werk het telefoonnummer bij op de pagina voor de bestellingsverwerking"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "1f8FkR",
        defaultMessage: [{
          "type": 0,
          "value": "Afhankelijk van je probleem en de status van je zending, kun je misschien het adres of telefoonnummer corrigeren tijdens de bestellingsverwerking. Je kunt het afzenderadres van de bestelling bewerken in ‘Stap 2. Verzending vanaf adres’ op de pagina bestellingsverwerking."
        }]
      }), strictLocalize({
        id: "xnaL/E",
        defaultMessage: [{
          "type": 0,
          "value": "Soms kan dit een typefout zijn, of is er een spatie waar die niet zou moeten zijn. Als het adres van de retailer ongeldig is, kun je de retailer rechtstreeks een bericht sturen of e-mailen door naar hun klantpagina te gaan. Neem contact met ons op als je nog steeds problemen ondervindt."
        }]
      })];
    }
  };
};